import { createSlice } from '@reduxjs/toolkit';
import { adminGetCallLogs } from './adminApi';

const initialState = {
  adminCallLogs: null,
  status: 'idle',
  error: null,
};

const callLogsSlice = createSlice({
  name: 'callLogs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminGetCallLogs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(adminGetCallLogs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.adminCallLogs = action.payload;
      })
      .addCase(adminGetCallLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default callLogsSlice.reducer;
